import {Component, OnInit} from '@angular/core';
import {CurrentRouteService} from '../currentRoute.service';
import {Router, ActivatedRoute} from '@angular/router';
import {AccountIdService, AgencyIdService} from "../account.service";

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.css','./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {

  helps: string[] = [
    "Copy and place tag for each page you want to track",
  ];

  agency_id: string;
  account_id: string;

  constructor(public router: Router,
              private route: ActivatedRoute,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private currentrouteService: CurrentRouteService,) {
  }

  ngOnInit(): void {

    console.log(this.router.url);
    this.currentrouteService.announceCurrentRoute(this.router.url);

    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id'],
        this.account_id = parms['account_id'],
        this.agencyidService.announceAgencyId(this.agency_id);
        this.accountidService.announceAccountId(this.account_id);
    });


  } //end ngOnInit


  public onCardClick(evt: MouseEvent, provider: string) {

    /*
     ng g c integrations-providers/integrations-googleads
     ng g c integrations-providers/integrations-clickfunnels
     */

    this.router.navigate(['/integrations','providers',provider, this.agency_id, this.account_id],); // { queryParams: { account_name: account_name }} { queryParams: { account_name: account_name }}relativeTo: this.route,

  } //end onCardClick


}
